import { render, staticRenderFns } from "./NewGroupForm.vue?vue&type=template&id=f470c53c&"
import script from "./NewGroupForm.vue?vue&type=script&lang=js&"
export * from "./NewGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports